function getFormData(obj: any = {}, formData = new FormData(), key = '') {
  if (![Array, File, Object].includes(obj.constructor)) {
    return formData;
  }

  // Handle File recursive
  if (obj instanceof File) {
    formData.append(key, obj);
    return formData;
  }

  for (const prop in obj) {
    // Validate value type
    if (
      obj[prop] &&
      ![String, Number, Boolean, Array, Object, File].includes(obj[prop].constructor)
    ) {
      continue;
    }

    // Set deep index of prop
    const deepKey = key ? key + `[${prop}]` : prop;

    // Handle array
    if (Array.isArray(obj[prop])) {
      obj[prop].forEach((item, index) => {
        if ([String, Number, Boolean].includes(item?.constructor))
          formData.append(`${deepKey}[${index}]`, item);
        else getFormData(item, formData, `${deepKey}[${index}]`);
      });
      continue;
    }

    if (typeof obj[prop] === 'object' && obj[prop] && obj[prop].constructor === Object) {
      getFormData(obj[prop], formData, deepKey); // Handle object
    } else {
      // Handle string, number, boolean
      // skip null, undefined
      if (![undefined, null].includes(obj[prop])) formData.append(deepKey, obj[prop]);
    }
  }

  return formData;
}

export default getFormData;
